import { ref } from 'vue'

// Global error modal state
const showErrorModal = ref(false)
const currentError = ref(null)

export function useErrorModal() {
  const showError = (error) => {
    currentError.value = error
    showErrorModal.value = true
  }

  const hideError = () => {
    showErrorModal.value = false
    currentError.value = null
  }

  const showApiError = (apiError) => {
    // Handle different error formats
    let formattedError = null
    
    if (typeof apiError === 'string') {
      formattedError = apiError
    } else if (apiError?.message) {
      // Standard Error object
      formattedError = apiError.message
    } else if (apiError?.error) {
      // API error response format: {"error":"Invalid transaction data","details":["category: must be equal to one of the allowed values"]}
      formattedError = {
        error: apiError.error,
        details: apiError.details || []
      }
    } else if (apiError?.response?.data) {
      // Axios error format
      const responseData = apiError.response.data
      formattedError = {
        error: responseData.error || responseData.message || 'Request failed',
        details: responseData.details || []
      }
    } else {
      formattedError = 'An unexpected error occurred'
    }
    
    showError(formattedError)
  }

  const showNetworkError = () => {
    showError({
      error: 'Network Error',
      details: [
        'Unable to connect to the server',
        'Please check your internet connection and try again'
      ]
    })
  }

  const showValidationError = (validationErrors) => {
    showError({
      error: 'Validation Error',
      details: Array.isArray(validationErrors) ? validationErrors : [validationErrors]
    })
  }

  return {
    showErrorModal,
    currentError,
    showError,
    hideError,
    showApiError,
    showNetworkError,
    showValidationError
  }
}